import { SIDEBAR_WIDTH } from "../consts/SIDEBAR_WIDTH";
import { useMediaQueryUp } from "./useMediaQueryUp";

export function useSidebarWidth(width: number = SIDEBAR_WIDTH) {
  const isUpMd = useMediaQueryUp("md");

  return isUpMd ? width : 0;
}
